import { NgModule, Provider } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthGuard } from './core';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { RefreshRedirectComponent } from './shared/components/refresh-redirect/refresh-redirect.component';

const ROUTES: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)},
  { path: 'change-password', loadChildren: () => import('./change-password/change-password.module').then(m => m.ChangePasswordModule) },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule), canLoad: [AuthGuard]},
  { path: 'configuration', loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule), canLoad: [AuthGuard] },
  { path: 'curtailment', loadChildren: () => import('./curtailment/curtailment.module').then(m => m.CurtailmentModule), canLoad: [AuthGuard] },
  { path: 'reporting', loadChildren: () => import('./reporting/reporting.module').then(m => m.ReportingModule), canLoad: [AuthGuard] },
  { path: 'status', loadChildren: () => import('./status/status.module').then(m => m.StatusModule), canLoad: [AuthGuard] },
  { path: 'refresh-redirect', component: RefreshRedirectComponent },
  { path: 'login', component: LoginComponent },
  { path: '**', redirectTo: 'dashboard'}
];

export const APP_ROUTING_COMPONENTS = [
  LoginComponent,
  ForgotPasswordComponent
]
@NgModule({
  imports: [
    RouterModule.forRoot(ROUTES, {})
  ],
  exports: [
    RouterModule
  ],
  providers:[]
})
export class AppRoutingModule { }
